import { IUser } from '@portal/entity-services/interfaces/src';
import { AppPermission } from './app-permission.interface';

export interface IAuthorizationInfo {
  user: IUser;
  appsPermissions: AppPermission[];
}
